var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "#DC2626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5335 40.5C21.8919 40.5 21.3426 40.2715 20.8856 39.8146C20.4287 39.3576 20.2002 38.8083 20.2002 38.1667V21.8333C20.2002 21.1917 20.4287 20.6424 20.8856 20.1854C21.3426 19.7285 21.8919 19.5 22.5335 19.5H30.7002V21.8333H22.5335V38.1667H30.7002V40.5H22.5335ZM35.3669 35.8333L33.7627 34.1417L36.7377 31.1667H27.2002V28.8333H36.7377L33.7627 25.8583L35.3669 24.1667L41.2002 30L35.3669 35.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLogout);
export default __webpack_public_path__ + "static/media/button-logout.690f9f50b7d66b3c3e938316df1bd02b.svg";
export { ForwardRef as ReactComponent };